import styled, { css } from 'styled-components';

type TBasicInput = {
  errorMessage?: string;
  inputSize?: string;
};

export const BasicInputStyles = styled.input<TBasicInput>(
  ({ theme, errorMessage, inputSize = 'md' }) => css`
    background: ${theme.colors.white};
    border: ${theme.borders.form};
    width: 100%;
    padding: ${inputSize !== 'sm' ? '0.75rem' : '0.25rem'};
    border-color: ${errorMessage ? theme.colors.main.error : undefined};

    :disabled,
    &.disabled {
      color: ${theme.colors.darkGrey};
      background-color: ${theme.colors.lightWhiteSmoke};
      opacity: 1;
    }

    ::placeholder {
      color: rgba(111, 111, 111, 0.5);
    }

    &:focus {
      border: 1px solid ${theme.colors.green};
    }
  `
);
